import localeCs from 'element-ui/lib/locale/lang/cs-CZ';
import localeEn from 'element-ui/lib/locale/lang/en';
import localeSk from 'element-ui/lib/locale/lang/sk';
import localeTw from 'element-ui/lib/locale/lang/zh-TW';
import elementLocalize from 'element-ui/lib/locale';
import { ActionTree } from 'vuex';

import { resourcesService } from '@/main/services';

import { Localization } from '@/main/localization';

import {
	LOCALIZATION_REQUEST,
	LOCALIZATION_SUCCESS,
	ERROR,
} from '../actionTypes';
import { RootStore } from '../@types/store';
import { LANGUAGE_CODE, LANGUAGE_ID } from '../constants';


export const actions: ActionTree<Localization, RootStore> = {
	async [LOCALIZATION_REQUEST]({ commit, dispatch }) {
		try {
			const languageCode = localStorage.getItem('i18nextLng');
			let languageId = null;

			if (languageCode === LANGUAGE_CODE.CZECH) {
				languageId = LANGUAGE_ID.CZECH;
			} else if (languageCode === LANGUAGE_CODE.MANDARIN) {
				languageId = LANGUAGE_ID.MANDARIN;
			} else if (languageCode === LANGUAGE_CODE.ENGLISH) {
				languageId = LANGUAGE_ID.ENGLISH;
			}

			const resp = await resourcesService.loadLocalizations(languageId);
			const { Language } = resp.data;
			if (!Language) throw new Error('Language from resource endpoint is not defined!');

			const locales = {
				cs: localeCs,
				en: localeEn,
				sk: localeSk,
				tw: localeTw,
			};
			if (locales[Language]) elementLocalize.use(locales[Language]);
			commit(LOCALIZATION_SUCCESS, resp.data);
			return resp;
		} catch (err) {
			dispatch(ERROR, { err }, { root: true });
			return err;
		}
	},
};
